import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { fuseAnimations } from '@barebone-fuse/@fuse/animations';
import {
  ActivityFeedInfo, ActivityFeedType, ActivityFilterModel, DateRangeEnumType,
  DefaultActivityFilterSettings
} from '../../../store/activity.model';
import {ActivatedRoute, Router} from '@angular/router';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Subject} from 'rxjs';
import {ActivityFilterSettings, ActivityTrackerHeaderMenuTypes} from '@shared/models/activity-tracker-header.model';
import {ActivityFilterService} from '../../../services/activity-filter.service';
import {take, takeUntil} from 'rxjs/operators';
import {ActivityDateRangeTypeScope} from '../../../store/activity-date-range-type-scope.model';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {Store} from '@ngrx/store';
import {
  SetActivityFeedAction
} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import {Guid} from 'guid-typescript';
import {TimeZoneService} from '@core/services/time-zone.service';
import moment_ from 'moment';


@Component({
    standalone: false,
    selector: 'particle-activities',
  templateUrl: './activities.component.html',
  styleUrls: ['./activities.component.scss'],
  animations: fuseAnimations
})
export class ActivitiesComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  invalidateSubject: InvalidateSubject;
  activityFeeds: Array<ActivityFeedInfo> = []; // they can be filter id
  defaultActivityFeed: ActivityFeedInfo;
  unSubscribe$ = new Subject<void>();
  isOpenFilterEditView: boolean = false;
  filterSettings: ActivityFilterSettings = JSON.parse(JSON.stringify(DefaultActivityFilterSettings));
  conversationId: string = '';
  messageId: string = '';
  activityFeedContentId: string = Guid.create().toString();

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private platformSidebarStore: Store<PlatformSidebarState>,
              protected timeZoneService: TimeZoneService,
              private activityFilterService: ActivityFilterService,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
/*      if (this.selectedTab && this.selectedTab.tabData && this.selectedTab.tabData && this.selectedTab.tabData.IsDraftFilter) {
        this.isDraftFilter = this.selectedTab.tabData.IsDraftFilter;
      }*/
      const type = params['type'];
      const id = params['id'];
      console.log('getting feed:', type,id);
      if (type && id) {
        this.defaultActivityFeed = new ActivityFeedInfo({
          type: this.activityFilterService.getFeedType(type),
          id: id,
          isDefault: true
        });
        this.addDefualtActivityOnFeed();
      }
    });
    this.activatedRoute.queryParams.subscribe(queryParams => {
      if (queryParams.conversationId) {
        this.conversationId = queryParams.conversationId;
      }
      if (queryParams.messageId) {
        this.messageId = queryParams.messageId;
      }
      if (queryParams.isEdit) {
        this.isOpenFilterEditView = queryParams.isEdit;
        const params = Object.assign({}, queryParams);
        delete params.isEdit;
        this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: params });
      }
      if (queryParams.isDraft) {
        this.isOpenFilterEditView = queryParams.isDraft;
        const params = Object.assign({}, queryParams);
        delete params.isDraft;
        this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: params });
      }
    });

    if (this.handler && this.handler.magicLinkModelValueChanged) {
      this.handler.magicLinkModelValueChanged.pipe(takeUntil(this.unSubscribe$)).subscribe(commamd => {
        this.handleMagicLinkValueChanged(commamd);
      });
    }
  }


  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onDrop() {
  }

  onAddNewFeed(feed: ActivityFeedInfo, index: any) {
    // console.log('activity feed to add:', event, index);
    if (feed && feed.type) {
      if (feed.type.toLowerCase() === ActivityFeedType.DateRange.toLowerCase()) {
        this.platformSidebarStore.dispatch(new SetActivityFeedAction(feed));
      } else {
        this.activityFeeds.splice(index + 1, 0, feed);
        this.activityFilterService.saveLinkedFilter(this.defaultActivityFeed.id, feed);
      }
    }
  }

  onRemoveActivityFeed(feed, index) {
    // console.log('activity feed to remove:', feed);
    if (!feed.isDefault) {
      this.activityFeeds.splice(index, 1);
      this.activityFilterService.removeLinkedFilter(this.defaultActivityFeed.id, feed);
    }
  }

  onFilterSettingChange($event, feedInfo) {
    console.log('filter change ', $event, feedInfo);
    if (!feedInfo.isDefault) {
      return;
    }
    this.filterSettings = $event;
    this.dispatchDataToHandler({action: {id: 'FilterSettingChanges'}, filterSettings: this.filterSettings});
  }

  dispatchDataToHandler(event) {
    this.handler.valueChanged(event);
  }

  private handleMagicLinkValueChanged(action: any) {
    // console.log('on activity feed:', action);
    if (action) {
      switch (action.name) {
        case 'ExportActivityCommand':
          this.onExportActivityFeeds();
          break;
      }
    }
  }

  private populateFilterSettingsAndSiblingFeeds() {
    if (this.defaultActivityFeed.type && this.defaultActivityFeed.type.toLowerCase() === ActivityFeedType.Filter.toLowerCase() && this.defaultActivityFeed.id) {
      this.activityFilterService.getActivityFilterByid(this.defaultActivityFeed.id).pipe(take(1)).subscribe((filter: ActivityFilterModel) => {
        if (filter && filter.id === this.defaultActivityFeed.id) {
          this.defaultActivityFeed.title = filter.title;
          this.defaultActivityFeed.auditTrail = filter.dataFilter.auditTrail;
          this.defaultActivityFeed.dateRangeType = ActivityDateRangeTypeScope.getDateRangeTypeId(filter.dateRangeFilter.dateRangeType);
          this.defaultActivityFeed.startDate = filter.dateRangeFilter.startDate;
          this.defaultActivityFeed.endDate = filter.dateRangeFilter.endDate;
          this.activityFeeds.push(this.defaultActivityFeed);
          // filter will not use filterSettings but siblings will use. Filter has filter settings on it
          this.filterSettings = new ActivityFilterSettings(
            {
              auditTrail: filter.dataFilter.auditTrail,
              dateRangeType: ActivityDateRangeTypeScope.getDateRangeTypeId(filter.dateRangeFilter.dateRangeType),
              startDate: filter.dateRangeFilter.startDate,
              endDate: filter.dateRangeFilter.endDate,
              activityFeedType: ActivityFeedType.Filter,
              activityHeaderMenuType: ActivityTrackerHeaderMenuTypes.AllActivity
            }
          );
          if (filter.linkedFilters && filter.linkedFilters.length > 0) {
            filter.linkedFilters.forEach(f => {
              this.changeDetectorRef.detectChanges();
              this.activityFeeds.push(new ActivityFeedInfo({
                type: f.feedType ? f.feedType : ActivityFeedType.ItemsKey,
                id: f.itemKey,
                title: f.title,
                isDefault: false
              }));
            });
          }
        }
      });
    } else if (this.defaultActivityFeed.type && this.defaultActivityFeed.id) {
      if (this.selectedTab && this.selectedTab.tabData && this.selectedTab.tabData && this.selectedTab.tabData.ActivityFeedTitle) {
        this.defaultActivityFeed.title = this.selectedTab.tabData.ActivityFeedTitle;
      } else {
        this.defaultActivityFeed.title = this.defaultActivityFeed.id;
      }
      this.defaultActivityFeed.auditTrail = true;
      this.defaultActivityFeed.dateRangeType = ActivityDateRangeTypeScope.getDateRangeTypeId(DateRangeEnumType.Last30Days);
      this.defaultActivityFeed.startDate = new Date(new Date().setDate(new Date().getDate() - 29));
      this.defaultActivityFeed.endDate = new Date();
      this.activityFeeds.push(this.defaultActivityFeed);
    }
  }

  private addDefualtActivityOnFeed() {
    this.activityFeeds = [];
    this.populateFilterSettingsAndSiblingFeeds();
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onLoad() {
  }

  private onExportActivityFeeds() {
    if (this.activityFeeds.length > 0) {
      const activityFeedInfos: Array<ActivityFeedInfo> = [];
      this.activityFeeds.forEach((feedInfo) => {
        feedInfo.auditTrail = this.filterSettings.auditTrail;
        feedInfo.dateRangeType = this.filterSettings.dateRangeType;
        feedInfo.startDate = this.getStartDate(this.filterSettings.startDate);
        feedInfo.endDate = this.getEndDate(this.filterSettings.endDate);
        activityFeedInfos.push(feedInfo);
      });
      // console.log('[activity feed export infos] ', activityFeedInfos);
      this.activityFilterService.exportActivityFeeds(activityFeedInfos);
    }
  }

  private getStartDate(dateTime: any) {
    // console.log('start datetime:', dateTime, typeof  dateTime);
    const startDate = new Date(dateTime);
    const sDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0);
    const moment = moment_;
    return moment.utc(sDate).toDate();
  }

  private getEndDate(dateTime: any) {
    // console.log('end datetime:', dateTime, typeof  dateTime);
    const endDate = new Date(dateTime);
    const eDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59);
    const moment = moment_;
    return moment.utc(eDate).toDate();
  }
}
